import { Col } from "react-bootstrap";

// hoisted so it isn't reallocated on every render (21 cards mount at once)
const coverStyle = {
  width: "100%",
  height: "220px",
  objectFit: "cover",
  objectPosition: "center",
};

export const ProjectCard = ({ title, description, imgUrl, projUrl }) => {
  return (
    <Col lg={4} sm={6} md={6}>
      <a
        href={projUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="block text-decoration-none"
      >
        <div className="proj-imgbx">
          <img
            src={imgUrl}
            alt={title}
            loading="lazy"
            decoding="async"
            style={coverStyle}
          />
          <div className="proj-txtx">
            <h4>{title}</h4>
            <span>{description}</span>
          </div>
        </div>
      </a>
    </Col>
  );
};
